// extracted by mini-css-extract-plugin
export var headingWrapper = "long_form_text_item-module--headingWrapper--t4-8g";
export var longFormTextItemWrapper = "long_form_text_item-module--longFormTextItemWrapper--JkFmU";